




























































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  FormVaildateToOut,
  IsMore
} from "@root/lib/decorator";
import dayjs from "dayjs";
import { downloadFile } from "@/lib/common";

const common = namespace("common");
const wtProductActivity = namespace("wtProductActivity");
const tags = namespace("tags");
const k2Coupon = namespace("k2Coupon");

@Component({ components: {} })
@pagination("getData", {
  pageSize: 50
})
@SearchbarControl()
@loading()
@FormVaildateToOut()
export default class CouponSummary extends Vue {
  @k2Coupon.Action queryCouponStatistics;
  @k2Coupon.Action exportCouponStatistics;
  @k2Coupon.Mutation toggleExpressFeesTab;
  total: any = 0;
  searchParams: any = {};
  async created() {
    this.init();
  }

  async init() {
    this.getData();
  }
  form: any = {
    month: ""
    // shopNameOrCode: ""
  };
  dataList = [];
  @loadingCatch
  async getData() {
    const { pageSize, currentPage: pageNum } = this as any;
    try {
      this.searchParams = this.form;
      let res = await this.queryCouponStatistics({
        pageSize,
        pageNum,
        ...this.form,
        shopNameOrCode: localStorage.getItem("memberCode")
      });
      this.total = res.total || 0;
      this.dataList = res.list || [];
    } catch (err) {
      this.dataList = [];
      this.total = 0;
    }
  }
  handleToDetail(row) {
    let monthList: any = row.month.split("-");
    let rowMonth: any = dayjs(new Date(monthList[0], monthList[1] - 1));
    let startTime: any =
      rowMonth.year() +
      "-" +
      String(rowMonth.month() + 1).padStart(2, "0") +
      "-01 00:00:00";
    let endTime: any =
      this.getNextMonth(monthList[0], monthList[1]) + "-01 00:00:00";
    console.log(startTime, endTime, "-startTime-endTime");
    this.toggleExpressFeesTab({
      type: "detail",
      detailMonth: [startTime, endTime],
      status: "03"
    });
  }

  exportLoading: any = false;
  // 导出
  async exportFn() {
    try {
      this.exportLoading = true;
      let formData = new FormData();
      formData.append(
        "AUTH-TOKEN",
        localStorage.getItem("AUTH-TOKEN-K-ONE-CN")
      );
      let input: any = {
        exportType: "1",
        shopNameOrCode: localStorage.getItem("memberCode"),
        ...this.searchParams
      };
      for (let i in input) {
        formData.append(i, input[i]);
      }
      let res: any = await this.exportCouponStatistics(formData);
      console.log(res, "000res");
      downloadFile(res.data, res.name || "");
    } finally {
      this.exportLoading = false;
    }
  }

  getNextMonth(year, month) {
    // 使用dayjs获取指定年月的下个月
    const nextMonth = dayjs(new Date(year, month - 1)).add(1, "month");

    // 返回下个月的年份和月份
    return (
      nextMonth.year() + "-" + String(nextMonth.month() + 1).padStart(2, "0")
    );
  }
}
